export default "/dist/blocks.editor.build.css";